
import { useEffect, useState } from "react";
import config from "../../../config/config";
import axios from "axios";
import { getAuthToken } from "../../../utils/token";

import PlanShiftList from "./PlanShiftList";
import PlanShiftModal from "./PlanShiftModal";
import PlanShiftDelete from "./PlanShiftDelete";


const PlanShift = () => {

    // =========================================================
    // PRODUCT MACHINE SETUPS
    // =========================================================

    const [setups, setSetups] = useState([]);

    const [loading, setLoading] = useState(false);

    const [error, setError] = useState("");


    // =========================================================
    // MASTER LISTS
    // =========================================================

    const [machines, setMachines] = useState([]);

    const [products, setProducts] = useState([]);

    const [dies, setDies] = useState([]);

    const [shifts, setShifts] = useState([]);

    const [listLoading, setListLoading] = useState(false);


    // =========================================================
    // MODALS
    // =========================================================

    const [showModal, setShowModal] = useState(false);

    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const [selectedSetup, setSelectedSetup] = useState(null);


    // =========================================================
    // GET PRODUCT MACHINE SETUPS
    // =========================================================

const fetchSetups = async () => {

    const token = getAuthToken();



    if (!token) {
        console.error("Authentication token not found.");
        setError("Authentication token not found.");
        return;
    }

    try {

        setLoading(true);
        setError("");

        const response = await axios.get(
            `${config.API}/planshift/index`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
            }
        );

        console.log(
            "HTTP Status:",
            response.status
        );

        console.log(
            "FULL API RESPONSE:",
            response
        );

        console.log(
            "API DATA:",
            response.data
        );

        console.log(
            "API RECORDS:",
            response.data?.data
        );

        if (response.data?.success === true) {

            const records = Array.isArray(
                response.data.data
            )
                ? response.data.data
                : [];

            console.log(
                "SETUP RECORDS:",
                records
            );

            console.log(
                "SETUP COUNT:",
                records.length
            );

            setSetups(records);

        } else {

            setSetups([]);

            setError(
                response.data?.message ||
                "Unable to load product machine setups."
            );

        }

    } catch (error) {

        console.error(
            "FETCH SETUPS ERROR:",
            error
        );

        console.error(
            "ERROR RESPONSE:",
            error.response?.data
        );

        console.error(
            "ERROR STATUS:",
            error.response?.status
        );

        setSetups([]);

        setError(
            error.response?.data?.message ||
            error.message ||
            "Failed to load product machine setups."
        );

    } finally {

        setLoading(false);

    }
};
    // =========================================================
    // GET MACHINE LIST
    // =========================================================

    const fetchMachineList = async () => {

        const token = getAuthToken();

        if (!token) return;

        try {

            const response = await axios.get(
                `${config.API}/machine/list`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "application/json",
                    },
                }
            );

            console.log(
                "Machine List:",
                response.data
            );

            setMachines(
                response.data.machines || []
            );

        } catch (error) {

            console.error(
                "fetchMachineList:",
                error.response?.data || error
            );

            setMachines([]);

        }
    };


    // =========================================================
    // GET PRODUCT LIST
    // =========================================================

    const fetchProductList = async () => {

        const token = getAuthToken();

        if (!token) return;

        try {

            const response = await axios.get(
                `${config.API}/product/list`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "application/json",
                    },
                }
            );

            console.log(
                "Product List:",
                response.data
            );

            setProducts(
                response.data.products || []
            );

        } catch (error) {

            console.error(
                "fetchProductList:",
                error.response?.data || error
            );

            setProducts([]);

        }
    };


    // =========================================================
    // GET DIE LIST
    // =========================================================

    const fetchDieList = async () => {

        const token = getAuthToken();

        if (!token) return;

        try {

            const response = await axios.get(
                `${config.API}/admin/lisdie`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "application/json",
                    },
                }
            );

            console.log(
                "Die List:",
                response.data
            );

            setDies(
                response.data.dies || []
            );

        } catch (error) {

            console.error(
                "fetchDieList:",
                error.response?.data || error
            );

            setDies([]);

        }
    };


    // =========================================================
    // GET PLAN SHIFT LIST
    // =========================================================

    const fetchShiftList = async () => {

        const token = getAuthToken();

        if (!token) return;

        try {

            const response = await axios.get(
                `${config.API}/planshift/list`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "application/json",
                    },
                }
            );

            console.log(
                "Shift List:",
                response.data
            );

            setShifts(
                response.data.data ||
                response.data.shifts ||
                []
            );

        } catch (error) {

            console.error(
                "fetchShiftList:",
                error.response?.data || error
            );

            setShifts([]);

        }
    };


    // =========================================================
    // LOAD ALL DATA
    // =========================================================

    useEffect(() => {

        const loadData = async () => {

            setListLoading(true);

            await Promise.all([
                fetchSetups(),
                fetchMachineList(),
                fetchProductList(),
                fetchDieList(),
                fetchShiftList(),
            ]);

            setListLoading(false);

        };

        loadData();

    }, []);


    // =========================================================
    // ADD
    // =========================================================

    const handleAdd = () => {

        setSelectedSetup(null);

        setError("");

        setShowModal(true);

    };


    // =========================================================
    // EDIT
    // =========================================================

    const handleEdit = (setup) => {

        console.log(
            "Edit Setup:",
            setup
        );

        setSelectedSetup(setup);

        setError("");

        setShowModal(true);

    };


    // =========================================================
    // DELETE CLICK
    // =========================================================

    const handleDelete = (setup) => {

        console.log(
            "Delete Setup:",
            setup
        );

        setSelectedSetup(setup);

        setShowDeleteModal(true);

    };


    // =========================================================
    // CLOSE FORM MODAL
    // =========================================================

    const closeModal = () => {

        setShowModal(false);

        setSelectedSetup(null);

    };


    // =========================================================
    // CREATE
    // =========================================================

    const handleCreate = async (data) => {

        const token = getAuthToken();

        if (!token) return;

        try {

            setLoading(true);

            console.log(
                "Create Setup Request:",
                data
            );

            const response = await axios.post(
                `${config.API}/planshift/create`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                }
            );

            console.log(
                "Create Setup Response:",
                response.data
            );

            if (response.data.success) {

                setShowModal(false);

                setSelectedSetup(null);

                await fetchSetups();

            } else {

                throw new Error(
                    response.data.message ||
                    "Failed to create setup."
                );

            }

        } catch (error) {

            console.error(
                "handleCreate:",
                error.response?.data || error
            );

            throw error;

        } finally {

            setLoading(false);

        }
    };


    // =========================================================
    // UPDATE
    // =========================================================

    const handleUpdate = async (id, data) => {

        const token = getAuthToken();

        if (!token) return;

        try {

            setLoading(true);

            console.log(
                "Update Setup:",
                id,
                data
            );

            const response = await axios.put(
                `${config.API}/planshift/update/${id}`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                }
            );

            console.log(
                "Update Setup Response:",
                response.data
            );

            if (response.data.success) {

                setShowModal(false);

                setSelectedSetup(null);

                await fetchSetups();

            } else {

                throw new Error(
                    response.data.message ||
                    "Failed to update setup."
                );

            }

        } catch (error) {

            console.error(
                "handleUpdate:",
                error.response?.data || error
            );

            throw error;

        } finally {

            setLoading(false);

        }
    };


    // =========================================================
    // DELETE
    // =========================================================

const handleConfirmDelete = async () => {
    const token = getAuthToken();

    if (!token) return;

    if (!selectedSetup?.id) {
        setError("Setup ID is missing.");
        return;
    }

    try {
        setLoading(true);
        setError("");

        console.log("DELETE ID:", selectedSetup.id);
        console.log(
            "DELETE URL:",
            `${config.API}/planshift/delete/${selectedSetup.id}`
        );

        const response = await axios.delete(
            `${config.API}/planshift/delete/${selectedSetup.id}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
            }
        );

        console.log("DELETE STATUS:", response.status);
        console.log("DELETE RESPONSE:", response.data);

        if (response.data?.success === true) {

            setShowDeleteModal(false);
            setSelectedSetup(null);

            await fetchSetups();

        } else {

            setError(
                response.data?.message ||
                "Delete API returned success=false."
            );
        }

    } catch (error) {

        console.error("DELETE ERROR:", error);
        console.error("DELETE STATUS:", error.response?.status);
        console.error("DELETE RESPONSE:", error.response?.data);

        setError(
            error.response?.data?.message ||
            error.message ||
            "Failed to delete setup."
        );

    } finally {
        setLoading(false);
    }
};


    // =========================================================
    // RENDER
    // =========================================================

    return (

        <div className="container-fluid p-4">


            {/* =================================================
                HEADER
            ================================================= */}

            <div className="d-flex justify-content-between align-items-center mb-1">
                <div>
            
                    <p className="text-muted mb-0">
                        Manage machine, product, die and shift planning
                    </p>

                </div>


                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleAdd}
                >
                    + Add Setup
                </button>

            </div>


            {/* =================================================
                ERROR
            ================================================= */}

            {error && (

                <div className="alert alert-danger">

                    {error}

                </div>

            )}


            {/* =================================================
                LIST
            ================================================= */}

                    <PlanShiftList
                setups={setups}
                loading={loading}
                onEdit={handleEdit}
                onDelete={handleDelete}
            />


            {/* =================================================
                INSERT / UPDATE MODAL
            ================================================= */}

            {showModal && (

                <PlanShiftModal
                    setup={selectedSetup}

                    machines={machines}

                    products={products}

                    dies={dies}

                    shifts={shifts}

                    loading={loading}

                    listLoading={listLoading}

                    onClose={closeModal}

                    onCreate={handleCreate}

                    onUpdate={handleUpdate}
                />

            )}


            {/* =================================================
                DELETE MODAL
            ================================================= */}

            {showDeleteModal && (

                <PlanShiftDelete
                    setup={selectedSetup}
                    loading={loading}

                    onClose={() => {

                        setShowDeleteModal(false);

                        setSelectedSetup(null);

                    }}

                    onConfirm={handleConfirmDelete}

                />

            )}

        </div>
    );
};


export default PlanShift;

